(function () {
  'use strict';

  if (window.TTFreeEbookGifts && window.TTFreeEbookGifts.version === '2.6.2') return;

  const currentScript = document.currentScript;
  const currentSrc = currentScript && currentScript.src ? currentScript.src : '';
  const coreSrc = currentSrc.replace(/tt-free-ebook-gifts\.js(?:\?.*)?$/, 'tt-free-ebook-gifts-core.js?v=2.6.2');

  function loadCore() {
    if (window.TTFreeEbookGifts && window.TTFreeEbookGifts.version === '2.6.2') return;
    if (!coreSrc || coreSrc === currentSrc) return;

    const existing = document.querySelector('script[data-tt-cart-gifts-core="true"]');
    if (existing) return;

    const script = document.createElement('script');
    script.src = coreSrc;
    script.defer = true;
    script.dataset.ttCartGiftsCore = 'true';
    document.head.appendChild(script);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadCore, { once: true });
  } else {
    loadCore();
  }
})();
